import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { GoBackButtonWithTitle, PageHeaderBoldTitle, PageWrapper } from 'components';

import { CreateQuickLinkForm } from '../../components';
import { ContentW } from './styles';

export function CreateQuickLinkPage(): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageWrapper>
      <GoBackButtonWithTitle
        title={t('common.back')}
        onClick={() => navigate(-1)}
        containerSx={{
          marginTop: 0,
          maxWidth: '100%',
        }}
      />
      <PageHeaderBoldTitle title={t('quickLinks.createLinkPageTitle')} />
      <ContentW>
        <CreateQuickLinkForm />
      </ContentW>
    </PageWrapper>
  );
}
